import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BlogListingBlock1 } from "./BlogListingBlock1";
import { BlogListingItemBlock } from "./BlogListingItemBlock";

export const blogListingBlocks: BlockExportMapping = {
  BlogListingBlock1,
  BlogListingItemBlock,
};
